import { throttle } from 'throttle-debounce';

export default function vhFixForIOS() {
    const setVh = throttle(100, () => {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

    setVh();

    window.addEventListener('resize', setVh);
}
